import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  tenant: boolean
  guarantor: boolean
}

export const DEFAULT_FILTER: Filter = {
  tenant: true,
  guarantor: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const ApplicantTypeFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Tenant"
      checked={filter.tenant}
      onChange={e => {
        onChangeFilter({
          ...filter,
          tenant: e.target.checked,
        })
      }}
    />
    <Checkbox
      label="Guarantor"
      checked={filter.guarantor}
      onChange={e => {
        onChangeFilter({
          ...filter,
          guarantor: e.target.checked,
        })
      }}
    />
  </>
)

export default ApplicantTypeFilter
